// extracted by mini-css-extract-plugin
export default {"tabs":"p_bH","tab-list":"p_bJ","tab":"p_bK","active":"p_bL"};